import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { jsx } from '@emotion/core';
import { Component } from 'react';
import { FloatingLabelInput } from '../FloatingLabelInput';
import { InlineFieldsContainer } from '../../Common';
import { validateName } from './validations';
import { splitFullName } from './utils';
import { isFunction, isObject, NON_WHITESPACE } from '../../../utils';

class FullName extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      showOneField: this.props.unifiedField
    });

    _defineProperty(this, "blurHandler", e => {
      e.persist();
      var {
        blurHandler
      } = this.props;
      var {
        id,
        value
      } = e.target;

      if (id === 'fullName' && value.length && NON_WHITESPACE.test(value)) {
        var {
          splitFn
        } = this.props;
        var {
          firstName,
          lastName
        } = isFunction(splitFn) ? splitFn(value) : splitFullName(value);
        firstName.validation = validateName(firstName.value);
        lastName.validation = validateName(lastName.value);
        this.setState(() => ({
          showOneField: false
        }), () => {
          if (isFunction(blurHandler)) {
            blurHandler(e, {
              firstName,
              lastName
            });
          }
        });
      } else if (isFunction(blurHandler)) {
        blurHandler(e);
      }
    });
  }

  render() {
    var {
      changeHandler,
      firstName,
      focusHandler,
      generateChangeHandlerMeta,
      labels,
      styleOverrides
    } = this.props;
    var {
      showOneField
    } = this.state;
    var isMetaGeneratorObject = isObject(generateChangeHandlerMeta);
    var changeHandlerMetaObject = generateChangeHandlerMeta;

    if (!isMetaGeneratorObject) {
      changeHandlerMetaObject = {
        firstName: generateChangeHandlerMeta,
        fullName: generateChangeHandlerMeta,
        lastName: generateChangeHandlerMeta
      };
    }

    return jsx("div", {
      css: styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.container
    }, showOneField && jsx(FloatingLabelInput, _extends({
      autoComplete: "name",
      blurHandler: this.blurHandler,
      changeHandler: changeHandler,
      displayError: firstName.displayError,
      error: firstName.error,
      focusHandler: focusHandler,
      generateChangeHandlerMeta: changeHandlerMetaObject.fullName,
      id: "fullName",
      label: labels.fullName,
      maxLength: "100",
      name: "name",
      required: true,
      validationFn: validateName,
      value: firstName.value
    }, styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.fullName)), !showOneField && jsx(InlineFieldsContainer, null, ['firstName', 'lastName'].map(type => {
      var _this$props, _this$props2;

      var isFirst = type.includes('first');
      var name = isFirst ? 'fname' : 'lname';
      var ariaDescribedBy = isFirst ? this === null || this === void 0 ? void 0 : (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.firstNameAriaDescribedBy : this === null || this === void 0 ? void 0 : (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.lastNameAriaDescribedBy;
      var {
        error,
        displayError,
        value
      } = this.props[type];
      return jsx(FloatingLabelInput, _extends({
        ariaDescribedBy: ariaDescribedBy,
        autoComplete: "".concat(isFirst ? 'given' : 'family', "-name"),
        blurHandler: this.blurHandler,
        changeHandler: changeHandler,
        displayError: displayError,
        error: error,
        focusHandler: focusHandler,
        generateChangeHandlerMeta: changeHandlerMetaObject[type],
        id: this.props["".concat(type, "Id")] || type,
        key: type,
        label: labels[type],
        maxLength: "100",
        name: this.props["".concat(type, "InputName")] || name,
        required: true,
        validationFn: validateName,
        value: value
      }, styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides[type]));
    })));
  }

}

_defineProperty(FullName, "defaultProps", {
  styleOverrides: {}
});

export { FullName };